/**
 * Created by wumian on 17/11/23.
 */



//数组中的  json去重  在排序  默认删除前者  从小到大排序  不会改变原数组
Array.prototype.jsonRepeatSort = function (key, typeSort = 'small',typeRepeat) {
  var that = this;
  let result = new Set(that);
  let arr = Array.from(result);

  for (var j = 0; j < arr.length; j++) {
    if (j < arr.length) {
      var one = arr[j][key];
      for (var i = j + 1; i < arr.length; i++) {
        if (one == arr[i][key]) {
          if (typeRepeat == 'next') {
            arr.splice(i, 1);//删除的是后者   直接改变原数组
            i--;
          } else {
            arr.splice(j, 1);//删除的是前者, 默认删除前者
            j--;
            break
          }
        }
      }
    }
  }


  var len = arr.length, j;
  var tempExchangVal;
  while (len > 0) {
    for (j = 0; j < len - 1; j++) {
      if (typeSort == 'small') {
        if (arr[j][key] > arr[j + 1][key]) {
          tempExchangVal = arr[j];
          arr[j] = arr[j + 1];
          arr[j + 1] = tempExchangVal;
        }
      } else {
        if (arr[j][key] < arr[j + 1][key]) {
          tempExchangVal = arr[j];
          arr[j] = arr[j + 1];
          arr[j + 1] = tempExchangVal;
        }
      }
    }
    len--;
  }
  return arr;


};




// WEBPACK FOOTER //
// ./src/assets/js/prototype.js